import { ReferenceBubble } from "@/Shared/ReferenceNumbers/Bubbles/Internal/ReferenceBubble";

export function ReferenceNumberQuestionBubble(props: {
  displayName?: string | undefined;
  small?: boolean | undefined;
}) {
  return (
    <ReferenceBubble
      small={props.small}
      heading={
        props.displayName
          ? `Enter a reference number related to your ${props.displayName.toLowerCase()}`
          : `Enter a reference number`
      }
    />
  );
}
